import React from "react";
import styled from "styled-components";
import "../../Assets/Styles/ContactUs/contact.css";
import { useTheme } from "@mui/material/styles";

export default function Contacts() {
  const theme = useTheme();

  const ContactContainer = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    
    @media (max-width: 768px) {
      padding: 0 15px;
    }
    
    @media (max-width: 480px) {
      padding: 0 0px;
    }
  `;

  const ContactTitle = styled.h1`
    line-height: 1.2;
    color: ${theme.palette.secondary.main};
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    margin: 0;
    padding: 50px 0 30px 0;
    text-align: center;
    font-weight: bold;
    font-size: clamp(2rem, 5vw, 3.125rem); /* Responsive font size */
    letter-spacing: -0.02em;
    
    /* Large screens */
    @media (min-width: 1200px) {
      font-size: 50px;
      padding: 30px 0 30px 0;
    }
    
    /* Medium screens */
    @media (max-width: 1199px) and (min-width: 768px) {
      font-size: 42px;
      padding: 45px 0 35px 0;
    }
    
    /* Small tablets */
    @media (max-width: 767px) and (min-width: 481px) {
      font-size: 36px;
      padding: 40px 0 30px 0;
      line-height: 1.1;
    }
    
    /* Mobile phones */
    @media (max-width: 480px) {
      font-size: 28px;
      padding: 30px 0 20px 0;
      line-height: 1.1;
      letter-spacing: -0.01em;
    }
    
    /* Extra small phones */
    @media (max-width: 360px) {
      font-size: 24px;
      padding: 20px 0 15px 0;
    }
  `;

  return (
    <ContactContainer>
      <ContactTitle>Contact Us</ContactTitle>
    </ContactContainer>
  );
}


